// global
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Image, Popup } from 'semantic-ui-react';
// local
// consts
import { 
    CYLINDER_STATE, 
    GHOST_CYLINDER_STATE, 
    CYLINDER_PRESSURE_MAP } from 'salvus-shared/consts/cylinder';
// images
import ic_delivery_today from 'app/_assets/img/ic_delivery_today.png';
import ic_delivery_today_white from 'app/_assets/img/ic_delivery_today_white.png';
import ic_delivery_tomorrow from 'app/_assets/img/ic_delivery_tomorrow.png';
import ic_delivery_tomorrow_white from 'app/_assets/img/ic_delivery_tomorrow_white.png';
import QuestionIcon from "app/_assets/icon/question-icon/QuestionIcon";
// css
import './PressureBar.scss';

function PressureBar(props) {
    const initState = ({ cylinderSize }) => {
        if (!cylinderSize) return null;

        const cylinderInfo = CYLINDER_PRESSURE_MAP[cylinderSize];
        const maxPressure = cylinderInfo.p;
        return {
            maxPressure,
            yellowPressure: maxPressure * 0.7,
            redPressure: maxPressure * 0.45,
        };
        
    }

    const [state, setState] = useState(null);

    useEffect(() => {
      const stateComponent = initState(props);
      console.log('stateComponent: ', stateComponent)
      setState(stateComponent)
    
      return () => {
        //
      }
    }, [props])
    



    const renderScheduled = state => {
        let src = props.inAlert ? ic_delivery_tomorrow_white : ic_delivery_tomorrow;
        let iconClass = 'tomorrow';
        if (state === CYLINDER_STATE.REQUESTED) {
            src = props.inAlert ? ic_delivery_today_white : ic_delivery_today;
            iconClass = 'today';
        }
        return (
            <div className={`pressure-bar scheduled`}>
                <div className="circle">
                    <Image src={src} className={iconClass} />
                </div>
            </div>
        );
    }

    const renderCircle = type => {
        return (
            <div className={`pressure-bar ${type}`}>
                <div className="circle">
                    <div className="mask" />
                    {props.isGhostCylinder && <QuestionIcon fill="#202124" size="22" opacity='0.4' />}
                </div>
            </div>
        );
    }

    const renderCurrent = pressure => {
        if (!state) return

        const { maxPressure, yellowPressure, redPressure } = state;
        pressure = Math.max(Math.min(pressure, maxPressure), 50);
        const top = -1 * ((pressure * 32) / maxPressure);
        let colorCls = 'green';
        if (pressure < yellowPressure && pressure >= redPressure) {
            colorCls = 'yellow';
        } else if (pressure < redPressure) {
            colorCls = 'red';
        }
        return (
            <div className={`pressure-bar ${colorCls}`}>
                <div className="circle">
                    <div className="mask" style={{ top }} />
                    {props.isGhostCylinder && <QuestionIcon fill="#202124" size="22" />}
                </div>
            </div>
        );
    }

    const commonCylinder = () => {
        let { pressure, state } = props;
        let trigger = null;
        let content = null;
        switch (state) {
            case CYLINDER_STATE.EMPTY:
                content = 'Vazio';
                trigger = renderCircle('empty');
                break;
            case CYLINDER_STATE.REQUESTED:
                content = 'Solicitação agendada';
                trigger = renderScheduled(state);
                break;
            case CYLINDER_STATE.PENDING:
                content = 'Solicitação pendente';
                trigger = renderScheduled(state);
                break;
            case CYLINDER_STATE.FULL:
                content = 'Cheio';
                trigger = renderCircle('full');
                break;
            case CYLINDER_STATE.CURRENT:
                content = `${pressure}`;
                trigger = renderCurrent(pressure);
                break;
            default:
                content = 'Vazio';
                trigger = renderCircle('empty');
                break;
        }

        return { 
            trigger,
            content
        }
    }

    const ghostCylinder = () => {
        let { pressure, ghostState } = props;
        let trigger = null;
        let content = null;
        switch (ghostState) {
            case GHOST_CYLINDER_STATE.CURRENT:
                content = `${pressure}`;
                trigger = renderCurrent(pressure);
                break;
            case GHOST_CYLINDER_STATE.EMPTY:
                content = 'Cheio';
                trigger = renderCircle('empty');
                break;
            default:
                content = 'Vazio';
                trigger = renderCircle('empty');
                break;
        }

        return { 
            trigger,
            content
        }
    }

    const { isGhostCylinder } = props;
    const cylinder = isGhostCylinder ? ghostCylinder() : commonCylinder();
    const { trigger, content } = cylinder;

    return <Popup trigger={trigger} content={content} size="tiny" inverted />;
}

PressureBar.propTypes = {
    pressure: PropTypes.number,
    state: PropTypes.number,
    ghostState: PropTypes.number,
    inAlert: PropTypes.bool,
    cylinderSize: PropTypes.number,
};

export default PressureBar;
